import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "m-searchListItem__block" }
const _hoisted_3 = {
  key: 0,
  class: "a-badgeThumb"
}
const _hoisted_4 = {
  class: "a-picture -with-ratio",
  style: {"padding-bottom":"100%"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "m-searchListItem__block" }
const _hoisted_7 = { class: "m-searchListItem__title" }
const _hoisted_8 = { class: "m-searchListItem__venue" }
const _hoisted_9 = { class: "m-searchListItem__dateTime -mobile" }
const _hoisted_10 = { class: "m-searchListItem__dateItem" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_12 = { class: "m-searchListItem__dateItem" }
const _hoisted_13 = { class: "m-searchListItem__dateItem" }
const _hoisted_14 = { class: "m-searchListItem__dateItem" }
const _hoisted_15 = { class: "m-searchListItem__dateItem" }
const _hoisted_16 = { class: "m-searchListItem__block" }
const _hoisted_17 = { class: "m-searchListItem__dateTime -is-alternative" }
const _hoisted_18 = { class: "m-searchListItem__dateItem" }
const _hoisted_19 = { class: "m-searchListItem__dateItem" }
const _hoisted_20 = { class: "m-searchListItem__labels -is-alternative" }
const _hoisted_21 = { class: "m-searchListItem__label" }
const _hoisted_22 = { class: "m-searchListItem__label" }
const _hoisted_23 = { class: "m-searchListItem__labels" }
const _hoisted_24 = { class: "m-searchListItem__label" }
const _hoisted_25 = { class: "m-searchListItem__label" }
const _hoisted_26 = { class: "m-searchListItem__dateTime" }
const _hoisted_27 = { class: "m-searchListItem__dateItem" }
const _hoisted_28 = { class: "m-searchListItem__dateItem" }
const _hoisted_29 = { class: "m-searchListItem__dateTime -is-alternative" }
const _hoisted_30 = { class: "m-searchListItem__dateItem" }
const _hoisted_31 = { class: "m-searchListItem__dateItem" }
const _hoisted_32 = { class: "m-searchListItem__labels -is-alternative" }
const _hoisted_33 = { class: "m-searchListItem__label" }
const _hoisted_34 = { class: "m-searchListItem__label" }
const _hoisted_35 = { class: "m-searchListItem__labels" }
const _hoisted_36 = { class: "m-searchListItem__label" }
const _hoisted_37 = { class: "m-searchListItem__label" }
const _hoisted_38 = { class: "m-searchListItem__dateTime" }
const _hoisted_39 = { class: "m-searchListItem__dateItem" }
const _hoisted_40 = { class: "m-searchListItem__dateItem" }
const _hoisted_41 = { class: "m-searchListItem__block" }
const _hoisted_42 = {
  class: "a-btnCta",
  type: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      href: _ctx.item.url,
      class: "m-searchListItem",
      "data-qa": "search-list-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSelectItem && _ctx.handleSelectItem(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.item.image)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("picture", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.staticUrl+_ctx.item.image,
                  alt: "",
                  role: "presentation"
                }, null, 8, _hoisted_5)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.item.title), 1),
        _createElementVNode("address", null, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.venue), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_icon_component, {
            "icon-id": _ctx.IconName.CalendarSmall,
            class: "m-searchListItem__icon"
          }, null, 8, ["icon-id"]),
          (_ctx.hasDateSpan)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.earliestStartDateNumeric), 1),
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.latestEndDateNumeric), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.earliestStartDate), 1),
                _withDirectives(_createElementVNode("span", _hoisted_14, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Date_at_label }]
                ]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.startTime), 1)
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.hasDateSpan)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isHungarianLanguage)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.earliestStartDate), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.latestEndDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createTextVNode(" – "),
                        _withDirectives(_createElementVNode("span", null, null, 512), [
                          [_directive_translate, { key: _ctx.Translation.Date_from_label }]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createTextVNode(" – "),
                        _withDirectives(_createElementVNode("span", null, null, 512), [
                          [_directive_translate, { key: _ctx.Translation.Date_to_label }]
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("span", _hoisted_24, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Date_from_label }]
                      ]),
                      _withDirectives(_createElementVNode("span", _hoisted_25, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Date_to_label }]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.earliestStartDate), 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.latestEndDate), 1)
                    ])
                  ], 64))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.isHungarianLanguage)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.earliestStartDate), 1),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.startTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("span", _hoisted_33, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Date_label }]
                      ]),
                      _withDirectives(_createElementVNode("span", _hoisted_34, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Time_label }]
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("span", _hoisted_36, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Date_label }]
                      ]),
                      _withDirectives(_createElementVNode("span", _hoisted_37, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Time_label }]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.earliestStartDate), 1),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.startTime), 1)
                    ])
                  ], 64))
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_41, [
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_42, [
          _createTextVNode("Tickets")
        ])), [
          [_directive_translate, { key: _ctx.Translation.List_button_label }]
        ]),
        _createVNode(_component_icon_component, {
          "icon-id": _ctx.IconName.Chevron,
          class: "m-searchListItem__iconCta"
        }, null, 8, ["icon-id"])
      ])
    ], 8, _hoisted_1)
  ]))
}